import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/** <cadence-button variant="primary|secondary|danger|ghost"> */
@customElement('cadence-button')
export class CadenceButton extends LitElement {
  @property() variant: 'primary' | 'secondary' | 'danger' | 'ghost' = 'primary';
  @property() type: 'button' | 'submit' = 'button';
  @property({ type: Boolean }) disabled = false;
  @property({ type: Boolean }) loading = false;
  @property({ type: Boolean, attribute: 'full-width' }) fullWidth = false;

  static styles = css`
    :host { display: inline-block; }
    :host([full-width]) { display: block; }
    button {
      font: inherit;
      font-weight: 600;
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: var(--radius-md);
      padding: 10px 18px;
      width: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: background 0.15s, border-color 0.15s, opacity 0.15s;
    }
    button:disabled { opacity: 0.55; cursor: not-allowed; }
    .primary { background: var(--color-primary); color: #fff; }
    .primary:hover:not(:disabled) { background: var(--color-primary-hover); }
    .secondary { background: var(--color-bg-secondary); color: var(--color-text-primary); border-color: var(--color-border); }
    .secondary:hover:not(:disabled) { border-color: var(--color-primary); }
    .danger { background: var(--color-danger); color: #fff; }
    .danger:hover:not(:disabled) { filter: brightness(1.08); }
    .ghost { background: transparent; color: var(--color-text-secondary); }
    .ghost:hover:not(:disabled) { background: var(--color-bg-secondary); }
    .spinner {
      width: 14px; height: 14px; border-radius: 50%;
      border: 2px solid currentColor; border-top-color: transparent;
      animation: spin 0.7s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
  `;

  render() {
    return html`
      <button
        class=${this.variant}
        type=${this.type}
        ?disabled=${this.disabled || this.loading}
        part="button"
      >
        ${this.loading ? html`<span class="spinner" aria-hidden="true"></span>` : ''}
        <slot></slot>
      </button>
    `;
  }
}
